import { render, staticRenderFns } from "./customerInfo.vue?vue&type=template&id=32d6eacc&scoped=true&"
import script from "./customerInfo.vue?vue&type=script&lang=js&"
export * from "./customerInfo.vue?vue&type=script&lang=js&"
import style0 from "./customerInfo.vue?vue&type=style&index=0&id=32d6eacc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6eacc",
  null
  
)

export default component.exports